module.exports = __webpack_public_path__ + "static/HazelValue3.ab49931e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/HazelValue3.jpg
// module id = 397
// module chunks = 246227742792961